import React from 'react'
import styles from './VendorModal.module.scss'
import { Grid } from '@mui/material'

function VendorModal({ children, img, className }) {
	return (
		<section className={`${styles.authCommonSection} ${className}`}>
			<div className="container">
				<div className={styles.inner}>
					<Grid
						container
						alignItems={'stretch'}
						sx={{
							height: '100dvh',
							maxHeight: '600px',
							'@media (max-width: 599px)': {
								maxHeight: '500px',
							},
						}}
						className={styles.gridBox}
					>
						{/* {img &&<Grid size={{ xs: 12, sm: 6 }}>
                            <div className={styles.imageContainer}>
                                <img
                                    src="/images/signup-img.png"
                                    alt="signup-img.jpg"
                                />
                            </div>
                        </Grid>} */}
						{children}
					</Grid>
					<div className={`${styles.bgImg}`}>
						<img src="/images/clock-img.png" alt="clock-img.png" />
					</div>
				</div>
			</div>
		</section>
	)
}

export default VendorModal
